import { DuplicateAttendanceError, type SubmitAttendanceInput } from '../api/attendance';
import type { PendingAttendance } from '../offline/queue';

export interface SubmitOrQueueDeps {
  uploadPhoto(assignmentId: string, clientUuid: string, photo: Blob): Promise<string>;
  uploadFormPhoto(clientUuid: string, fieldId: string, photo: Blob): Promise<string>;
  submit(input: SubmitAttendanceInput): Promise<{ id: string }>;
  enqueue(pending: PendingAttendance): Promise<void>;
}

/** Intenta enviar el marcado ahora; si algo falla lo deja en la cola local para el
 *  próximo flush(). Un duplicado del servidor es éxito: el marcado ya está registrado. */
export async function submitOrQueue(
  pending: PendingAttendance,
  deps: SubmitOrQueueDeps,
): Promise<'sent' | 'queued'> {
  try {
    const photoPath = await deps.uploadPhoto(
      pending.assignmentId,
      pending.clientUuid,
      pending.photoBlob,
    );

    const extra: { fieldId: string; value: string }[] = [];
    for (const fp of pending.formPhotos) {
      const path = await deps.uploadFormPhoto(pending.clientUuid, fp.fieldId, fp.blob);
      extra.push({ fieldId: fp.fieldId, value: path });
    }

    await deps.submit({
      clientUuid: pending.clientUuid,
      assignmentId: pending.assignmentId,
      kind: pending.kind,
      deviceTs: pending.deviceTs,
      lat: pending.lat,
      lng: pending.lng,
      accuracy: pending.accuracy,
      photoPath,
      origin: 'online',
      flags: pending.flags,
      formResponses: [...pending.formResponses, ...extra],
    });
    return 'sent';
  } catch (err) {
    if (err instanceof DuplicateAttendanceError) return 'sent';
    await deps.enqueue(pending);
    return 'queued';
  }
}
